import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class FileGroupingFileSpecSearchCriteria extends ValueObject {
    public searchCriteria: string = "";

    public staticServiceProviderFileGroupingID: number | null = null;

    public staticFileSpecID: number | null = null;

    public serviceProviderGroupingName: string | null = null;

    public fileTypeConcatenated: string | null = null;
}